import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, useLocation } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import LoginScreen from "pages/login-screen";
import PrintCard from "pages/print";
import Dashboard from "pages/dashboard";
import AddEditMember from "pages/add-edit-member";
import AllocatedMembersManagement from "pages/allocated-members-management";
import UnallocatedMembersManagement from "pages/unallocated-members-management";
import NotFound from "pages/NotFound";
import ReportPage from "pages/reports";
import DeploymentRegCount from "pages/reports/components/DeploymentRegCount";
import Header from "components/ui/Header";
import ManagePage from "pages/manages";
import Footer from "components/ui/Footer";
import RequiredServicesManagement from "pages/required-services-management";
import AllocationStats from "pages/allocation-stats";

const AppRoutes = () => {
  const location = useLocation();

  // Hide header/footer for print page
  const hideLayout = location.pathname === "/printCard";

  return (
    <ErrorBoundary>
      <ScrollToTop />

      {/* Conditionally render header and footer */}
      {!hideLayout && <Header />}

      <RouterRoutes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/printCard" element={<PrintCard />} />
        <Route path="/login-screen" element={<LoginScreen />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/add-edit-member" element={<AddEditMember />} />
        <Route path="/manage" element={<ManagePage />} />
        <Route path="/required-services-management" element={<RequiredServicesManagement />} />
        <Route path="/allocated-members-management" element={<AllocatedMembersManagement />} />
        <Route path="/unallocated-members-management" element={<UnallocatedMembersManagement />} />
        <Route path="/allocation-stats" element={<AllocationStats />} />
        <Route path="/reports" element={<ReportPage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>

      {!hideLayout && <Footer />}
    </ErrorBoundary>
  );
};


const Routes = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default Routes;